// extracted by mini-css-extract-plugin
export var card = "styles-module--card--gQWRz";
export var image = "styles-module--image--vLvxR";
export var content = "styles-module--content--MWxNR";
export var title = "styles-module--title---D5mZ";
export var meta = "styles-module--meta--4Y4Vl";
export var location = "styles-module--location--emips";
export var type = "styles-module--type--W6nZ2";